
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import type { UserProfile } from "@/integrations/mysql/client";

interface UseLoginRedirectProps {
  user: UserProfile | null;
  authLoading: boolean;
  justLoggedIn: boolean;
  isAdmin: boolean;
  setJustLoggedIn: (value: boolean) => void;
}

export function useLoginRedirect({
  user,
  authLoading,
  justLoggedIn,
  isAdmin,
  setJustLoggedIn,
}: UseLoginRedirectProps) {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [searchParams] = useSearchParams();
  const isAdminPanel = searchParams.get('admin') === 'true';

  useEffect(() => {
    if (user && !authLoading && justLoggedIn) {
      if (isAdminPanel && isAdmin) {
        setJustLoggedIn(false);
        return;
      } else if (isAdminPanel && !isAdmin) {
        toast({
          title: "Acesso negado",
          description: "Você não tem permissão para acessar o painel administrativo.",
          variant: "destructive",
        });
        setJustLoggedIn(false);
        navigate("/inicio");
        return;
      }
    }
  }, [user, authLoading, justLoggedIn, isAdmin, isAdminPanel, navigate, toast, setJustLoggedIn]);

  return { isAdminPanel };
}
